import { useTranslation } from "react-i18next";
import {
    MultiSelect,
    Select,
} from "@mantine/core";
import { Question, QuestionConditionType } from "src/graphql/generated/graphql";
import { handleError } from "src/utils/error";

import { useQuestionnaireFormContext } from "../formContext";

export interface ConditionValueProps {
    questionIndex: number;
    dependsOn: Question;
}

export const ConditionValue = ({ questionIndex, dependsOn }: ConditionValueProps) => {
    const { t } = useTranslation(["common"]);

    const questionnaireForm = useQuestionnaireFormContext();

    const question = questionnaireForm.values?.questions?.[questionIndex];

    let value;
    switch (question?.condition?.type) {
        case QuestionConditionType.None:
            return null;
        case QuestionConditionType.Oneof:
            value = [];
            try {
                if (question?.condition?.requiredValue) {
                    value = JSON.parse(question?.condition?.requiredValue);
                }
            } catch (err) {
                handleError(err, { context: { questionIndex } });
            }

            return (
                <MultiSelect
                    {...questionnaireForm.getInputProps(`questions.${questionIndex}.condition.requiredValue`)}
                    label={t("questionnaire_question_condition_requiredvalue")}
                    placeholder={t("questionnaire_question_condition_requiredvalue")}
                    data={(dependsOn?.options || []).map(option => ({
                        value: option?.key,
                        label: option?.text,
                    }))}
                    value={value}
                    onChange={value =>
                        questionnaireForm.setFieldValue(`questions.${questionIndex}.condition.requiredValue`, JSON.stringify(value))}
                />
            );
        case QuestionConditionType.Eq:
            value = null;
            try {
                if (question?.condition?.requiredValue) {
                    value = JSON.parse(question?.condition?.requiredValue);
                }
            } catch (err) {
                handleError(err, { context: { questionIndex } });
            }

            return (
                <Select
                    {...questionnaireForm.getInputProps(`questions.${questionIndex}.condition.requiredValue`)}
                    label={t("questionnaire_question_condition_requiredvalue")}
                    placeholder={t("questionnaire_question_condition_requiredvalue")}
                    data={(dependsOn?.options || []).map(option => ({
                        value: option?.key,
                        label: option?.text,
                    }))}
                    value={value}
                    onChange={value =>
                        questionnaireForm.setFieldValue(`questions.${questionIndex}.condition.requiredValue`, JSON.stringify(value))}
                />
            );
    }

    return null;
};
